module.exports = __webpack_public_path__ + "img/bar-chart-3.e566329f.svg";